import { computed, defineComponent } from "vue"; // modules

import AuthModule from "@/store/modules/auth"; // components

import { AsideOrderSummary } from "@/components/index";
export default defineComponent({
  name: "AppMain",
  components: {
    AsideOrderSummary: AsideOrderSummary
  },
  setup: function setup() {
    var isInBooking = computed(function () {
      return AuthModule.isInBooking;
    });
    return {
      isInBooking: isInBooking
    };
  }
});